export * from '@lexical/react/LexicalCollaborationPlugin'
